module.exports = __webpack_public_path__ + "media/gallery/photo10-8aa3dfb6.webp";